// Dot navigation shared by the line and timeline graphs. In pair mode their series data is
// [start, end, null, start, end, …]: the null gaps that break the line between pairs shift the chart's
// data indexes away from the dot indexes, so both directions need converting.

export function toDotIndex(seriesDataIndex: number, pairMode: boolean): number {
  return pairMode ? seriesDataIndex - Math.floor(seriesDataIndex / 3) : seriesDataIndex;
}

export function toSeriesDataIndex(dotIndex: number, pairMode: boolean): number {
  return pairMode ? dotIndex + Math.floor(dotIndex / 2) : dotIndex;
}

// Dot after the selected one, wrapping around; the first one when nothing is selected.
export function getNextDotIndex(selectedDotIndex: number | null, dotCount: number): number {
  if (dotCount === 0 || selectedDotIndex === null) {
    return 0;
  }

  return (selectedDotIndex + 1) % dotCount;
}
